import React from "react";

import { SpreadOverviewItem } from "./spread-overview-item";
import { useSpreadName } from "../../hooks/useSpreadName";
import { useDashboardContext } from "../../contexts/dashboard-context";

/** Contains one spread thumb with allowed buttons */
export const SpreadOverviewItemContainer = ({
	spread,
	isSelected,
	onSelect,
	canAddSpreads,
}: {
	spread: eXpress.core.Spread;
	isSelected: boolean;
	onSelect: () => void;
	// true = enabled, false = disabled, null = invisible
	canAddSpreads: boolean | null;
}) => {
	const spreadName = useSpreadName(spread) ?? "";
	const dashboard = useDashboardContext();

	return (
		<SpreadOverviewItem
			spread={spread}
			spreadName={spreadName}
			hideAddSpreadButton={canAddSpreads === null}
			disableAddSpreadButton={!canAddSpreads}
			onAddSpread={() => dashboard.addNewSpreadAfter(spread.index)}
			isSelected={isSelected}
			onSelect={onSelect}
		/>
	);
};
